'use client'

import React, { forwardRef } from 'react'
import s from './Textarea.module.scss'

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  className?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className={s.textareaGroup}>
        {label && (
          <label className={s.label}>
            {label}
            {props.required && ' *'}
          </label>
        )}
        <textarea
          ref={ref}
          className={`${s.textarea} ${error ? s.error : ''} ${className}`}
          {...props}
        />
        {error && <span className={s.errorText}>{error}</span>}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'
